import {Day} from "../interfaces/EmployeeInterface";
import { Task } from "../interfaces/ExcelUploadInterface";

    export const getTotalAmount = (tasks: Task[]) => {
        return tasks.reduce((total, task) => total + task.originalAmount, 0);
    }; 

    export const getTotalProjectClaimedForDay = (day: Day): number => {
        let total = 0;
      
        // Total from Project Tasks
        const projectTasks = day.projectEmployeeTasks;
        for (const task of projectTasks) {
          total += task.totalAmountClaimed;
        }
      
        // Total from Sick Claims
        const sickClaims = day.employeeSickClaims;
        for (const sick of sickClaims) {
          total += sick.amountClaimed;
        }
      
        // Total from Operational Tasks
        const operationalTasks = day.employeeOperationalTasks;
        for (const opTask of operationalTasks) {
          total += opTask.amountClaimed ?? 0; // Or opTask.amountClaimed if available
        }
      
        // Total from Warranty Tasks
        const warrantyTasks = day.employeeCustomerServiceWarrantyTasks;
        for (const warranty of warrantyTasks) {
          total += warranty.amountClaimed;
        }

        // Total from Work Order Hour Claims (hoursClaimed * laborPerHour)
        const workOrderTasks = day.employeeWorkOrderTasks ?? [];
        for (const workOrder of workOrderTasks) {
          total += workOrder.amountImplied ?? 0;
        }

        return total;
      };

      export const getTotalAmountForWeek = (days: Day[]) => {

        let total = 0;

        days.forEach(day => {

            total += getTotalProjectClaimedForDay(day);
            
        });

        return Number(total.toFixed(2));

      }

      export const getTotalTaskCountForWeek = (days: Day[]) => {

        let total = 0;

        days.forEach(day => {

            // Total from Project Tasks
            const projectTasks = day.projectEmployeeTasks;
            projectTasks.forEach(task => {

                total += task.employeeTasks.length;
                total += task.miscEmployeeTasks.length;
                
            });
        
            // Total from Sick Claims
            const sickClaims = day.employeeSickClaims;
            total += sickClaims.length;
        
            // Total from Operational Tasks
            const operationalTasks = day.employeeOperationalTasks;
            total += operationalTasks.length;
        
            // Total from Warranty Tasks
            const warrantyTasks = day.employeeCustomerServiceWarrantyTasks;
            total += warrantyTasks.length;
            
        });

        return total;

      }

      export const hasSickClaimsWithZeroAmount = (days: Day[]): boolean => {
        return days.some(day =>
          day.employeeSickClaims?.some(claim => claim.amountClaimed === 0)
        );
      };

      export const getSickClaimList = (days: Day[]): number[] => {
        return days.flatMap(day =>
          day.employeeSickClaims.map(claim => claim.employeeSickClaimID)
        );
      };      
      
      export const findIssues = (days: Day[]): string => {

        let issues = [];

        if(hasSickClaimsWithZeroAmount(days)){
          issues.push("Sick Claims")
        }

        if(issues.length > 0){

          const issueString = issues.join(", ");
          return issueString;

        }

        return "";

      }
      
